// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-size-dialog{margin-top:50px}.container-size-dialog img{max-width:350px}.container-image img{max-width:300px}.container-type-radio-group p{font-size:2rem}@media screen and (max-width:480px){.container-image img{max-width:125px!important}.container-size-dialog img{max-width:200px}.container-size-dialog .headline{font-size:1.2rem!important}}@media screen and (max-width:768px){.container-image img{max-width:250px}}", ""]);
// Exports
module.exports = exports;
